export default __webpack_public_path__ + "static/media/CM_loader_dark.72d88f9b.png";